<template>
    <div  class="container">
        <section id="contact-one" :class="['section']">
            <h1 class="title">Hablemos de cómo transformar tus ideas en soluciones reales.<br> Estamos listos para empezar.</h1>
            <img src="../assets/contactSelk.svg">
        </section>
        <!-- Canal preferido por la mayoría de nuestros clientes: va primero. -->
        <section id="contact-whatsapp" :class="['section']">
            <h2 class="subtitle whatsapp-title">¿Prefieres escribirnos directo?</h2>
            <p class="text whatsapp-text">
                La mayoría de nuestros clientes nos escribe por WhatsApp: respondemos
                más rápido y puedes enviarnos fotos, medidas o archivos desde el celular.
            </p>
            <WhatsAppButton variant="inline" label="Escríbenos por WhatsApp" />
        </section>

        <section id="contact-two" :class="['section']">
            <form @submit.prevent="sendMail()">
                <h2 class="subtitle form-title">O déjanos tus datos</h2>
                <input v-model="mailInfo.name" class="textguide" type="text" placeholder="Ingresa tu nombre" required>
                <input v-model="mailInfo.email" class="textguide" type="email" placeholder="Ingresa tu correo" required>
                <textarea v-model="mailInfo.message" class="textguide" type="text" placeholder="Cuéntanos sobre tu proyecto" required></textarea>

                <label class="consent">
                    <input v-model="consent" type="checkbox" required>
                    <span class="text consent-text">
                        Autorizo el tratamiento de mis datos personales conforme a la
                        <router-link to="/privacidad">política de privacidad</router-link>.
                    </span>
                </label>

                <button class="button btn--block" :disabled="sending || !consent">{{ sending ? 'Enviando...' : 'Enviar mensaje' }}</button>
                <p class="form-hint text">Te respondemos en menos de 24 horas hábiles.</p>
                <p v-if="status === 'ok'" class="form-feedback form-ok">¡Gracias! Recibimos tu mensaje y te contactaremos pronto.</p>
                <p v-if="status === 'error'" class="form-feedback form-error">Hubo un error al enviar el mensaje. Intenta de nuevo o escríbenos por WhatsApp.</p>
            </form>
            <div v-if="company">
                <h2 class="subtitle contact-data-title">Contáctanos</h2>
                <p class="text"> {{ company.email}}</p>
                <p class="text">{{ company.phone}}</p>
                <!-- <p class="text">{{ company.address }}</p> -->
                <img src="../assets/phoneSelk.svg">
            </div>
            <div v-else>
                <p>Cargando datos de la empresa...</p>
            </div>
        </section>
    </div>
</template>

<script>
import { inject } from 'vue';
import { sendMail } from '@/services/taskService';
import WhatsAppButton from './WhatsAppButton.vue';
    export default {
        name: 'ContactPage',
        components: { WhatsAppButton },
        setup() {
            const company = inject('company');
            return { company };
        },
        data() {
            return {
                mailInfo: {
                    name: "",
                    email: "",
                    message: ""
                },
                // Fuera de `mailInfo` para no alterar el payload que espera el backend.
                consent: false,
                sending: false,
                status: null // 'ok' | 'error' | null
            }
        },
        methods:{
            async sendMail() {
                this.sending = true;
                this.status = null;
                const {mail, error} = await sendMail(this.mailInfo)
                this.sending = false;
                if (mail) {
                    this.status = 'ok';
                    this.mailInfo = { name: "", email: "", message: "" };
                    this.consent = false;
                } else {
                    this.status = 'error';
                    console.error(error);
                }
            }
        }
    }
</script>

<style scoped>
#contact-one {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}
.form-hint {
    font-size: 16px !important;
    opacity: 0.75;
    margin-top: 0.5rem;
}
#contact-whatsapp {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}
.whatsapp-title {
    text-align: center;
    margin-bottom: 0.5rem;
}
.whatsapp-text {
    max-width: 42rem;
    text-align: center;
    margin: 0 0 1.5rem 0;
}
.form-title,
.contact-data-title {
    text-align: center;
    font-size: 28px;
    margin-bottom: 1rem;
}
.consent {
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    text-align: left;
    margin: 0.5rem 0 1rem 0;
}
.consent input {
    width: 20px;
    height: 20px;
    min-width: 20px;
    margin: 0.15rem 0 0 0;
    accent-color: #526D82;
    border: none;
}
.consent-text {
    font-size: 16px !important;
    line-height: 1.4;
}
.consent-text a {
    color: #526D82;
}
.form-feedback {
    margin-top: 0.5rem;
    font-weight: 600;
    border-radius: 8px;
    padding: 0.6rem 0.8rem;
}
.form-ok {
    color: #1b5e20;
    background: #e8f5e9;
}
.form-error {
    color: #b71c1c;
    background: #ffebee;
}
button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
#contact-one h1 {
    margin: 3vw 0 5vw 0;
}
#contact-two {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
}
form {
    align-items: left;
    text-align: center;
    margin-right: 20%;
}
#contact-two > div {
    display: flex;
    flex-direction: column;
    text-align: center;
}
#contact-two > div p {
    margin: 0.3vw 0;
}
#contact-two > div img {
    height: 15vw;
    max-height: 220px;
    width: auto;
}

@media (max-width: 800px){
    img {
        width: 140%;
    }
    form {
        width: 80%;
    }
    /* Alturas mínimas y tipografía de 16px las define global.css (R5):
       aquí solo se fija el ancho. */
    input {
        width: 100%;
    }
    textarea{
        width: 100%;
    }
    #contact-one img{
        content: url(../assets/contactSelk_Movile.svg);
        width: 120%;
        height: auto;
    }
    #contact-one h1 {
        margin: 0;
    }
    #contact-two {
        flex-direction: column;
        align-items: center;
        width: 100%;
    }
}
</style>